const getToken = () => {
  const queryParameters = new URLSearchParams(window.location.search);
  const token = queryParameters.get('id');
  return token || '';
};

export default getToken;
